module.exports = __webpack_public_path__ + "assets/font/MiSans-Medium-0ed777e3.otf";